import { ReactElement, ReactNode } from 'react';
import styled from 'styled-components';

import { Box, List as MuiList, ListItem as MuiListItem } from '@breathelife/mui';

import { Bullet as BulletIcon } from '../../Images/icons/Bullet';
import { Checkmark as CheckmarkIcon } from '../../Images/icons/Checkmark';

type IconType = 'checkmark' | 'bullet';

function getListStyleIcon(iconType: IconType): ReactElement | undefined {
  switch (iconType) {
    case 'checkmark':
      return <CheckmarkIcon />;

    case 'bullet':
      return <BulletIcon />;

    default:
      return;
  }
}

export const StyledList = styled(MuiList)<{ $noSpacing?: boolean }>`
  && {
    margin: 0;
    padding: 0;
    color: ${(props) => props.theme.colors.grey[90]};
    line-height: 1.5;

    li {
      align-items: initial;
      margin: 0;
      padding: 0;
      margin-bottom: ${({ $noSpacing }) => ($noSpacing ? '0' : '10px')};

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`;

type ListItemProps = {
  children: ReactNode;
  iconType: IconType;
};

export function ListItem(props: ListItemProps): ReactElement {
  const { children, iconType } = props;
  const icon = getListStyleIcon(iconType);
  return (
    <MuiListItem>
      <Box minWidth='12px' textAlign='center'>
        {icon}
      </Box>
      <Box ml={1}>{children}</Box>
    </MuiListItem>
  );
}

type ListProps = {
  children: ReactNode;
  noSpacing?: boolean;
};

export function List(props: ListProps): ReactElement {
  const { children, noSpacing } = props;
  return <StyledList $noSpacing={noSpacing}>{children}</StyledList>;
}
